import React, { useEffect, useState } from 'react';
import { Form, notification, Radio } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import './LanguagePrefEdit.scss';
import DrawerFormContainer from 'components/drawerFormContainer/DrawerFormContainer';
import { fetchAndUpdateProfileWithPartialProperties } from 'services/profileService';
import { MemberProfile } from 'types/dto/profile';
// import { useSession } from 'context/SessionContext';

interface LanguagePrefEditProps {
  profile?: MemberProfile;
  visible: boolean;
  onClose: () => void;
  onSave?: () => void;
}

const LanguagePrefEdit: React.FC<LanguagePrefEditProps> = ({
  profile,
  visible,
  onClose,
  onSave,
}) => {
  const { t, i18n } = useTranslation('profile');
  const { t: tCommon } = useTranslation('common');
  const [form] = Form.useForm();
  const [, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  // const {session} = useSession();

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      setIsSubmitting(true);

      try {
        await fetchAndUpdateProfileWithPartialProperties(profile?.loyalty_account?.unique_id || '', {language: values.language,});

        // Switch the active UI language and navigate to the new language URL
        const newLang = values.language;
        const currentLang = i18n.language;
        if (newLang !== currentLang) {
          i18n.changeLanguage(newLang);
          navigate(
            location.pathname.replace(`/${currentLang}`, `/${newLang}`),
            { replace: true }
          );
        }

        onSave?.();
      } catch (error) {
        notification.error({
          message: tCommon('error.updateLangPrefFailed'),
          description: (error as Error).message,
          duration: 1.5,
        });
      }
    } catch (error) {
      console.error('Validation failed:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (visible) {
      form.setFieldsValue({language: profile?.preference.language.toLocaleLowerCase(),});
    }
  }, [form, profile?.preference.language, visible]);

  return (
    <DrawerFormContainer
      title={t('languagePref.title')}
      visible={visible}
      onClose={onClose}
      onSave={handleSave}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{language: profile?.preference.language.toLocaleLowerCase(),}}
        className="language-pref-edit-form"
      >
        {/* Language Selection Radio Group */}
        <Form.Item name="language">
          <Radio.Group className="language-pref-edit-radio-group">
            <Radio value="en">{t('languagePref.english')}</Radio>
            <Radio value="zh">{t('languagePref.chinese')}</Radio>
          </Radio.Group>
        </Form.Item>
      </Form>
    </DrawerFormContainer>
  );
};

export default LanguagePrefEdit;
